import React from "react";
import PropTypes from "prop-types";
import PageTemplate from "../../templates/PageTemplate";
import MealSelectorContent from "../../organisms/MealSelectorContent";

function MealSelector(props) {
  const { customerId, mealConstructorCollections, mode, mealSettings } = props;
  return (
    <PageTemplate>
      <MealSelectorContent
        customerId={customerId}
        mealConstructorCollections={mealConstructorCollections}
        mode={mode}
        mealSettings={mealSettings}
      />
    </PageTemplate>
  );
}

MealSelector.propTypes = {
  customerId: PropTypes.number,
  mealConstructorCollections: PropTypes.object,
  mode: PropTypes.string,
  mealSettings: PropTypes.object,
};

export default MealSelector;
